<!-- eslint-disable -->
<template lang="pug">
    course-form(:course="course" :submit="create")
        template(slot="title") {{ $i18n.t('course.course_create_title') }}
        template(slot="button") {{ $i18n.t('course.course_create_button') }}
</template>

<script>
    /*eslint-disable*/
    import CourseForm from './Form.vue';
    import CourseApi from '../../api/course'
    import availableLocales from "../../utils/trainer/availableLocales";

    export default {
        data() {
            const translations = availableLocales.locales.map(locale => ({
                locale,
                name: '',
                description: ''
            }))
            return {
                course: {
                    status: 'active',
                    translations,
                    games: []
                }
            }
        },
        mounted() {
            if (!this.$can('addItem', 'course')) {
                this.$router.push({ name: '403' });
            }
        },
        methods: {
            create(course) {
                return CourseApi.create(course)
                    .then((data) => {
                        this.$router.push({name: 'course:profile', params: {id: data.id}});
                    })
            }
        },
        components: {
            CourseForm
        },
        beforeRouteLeave (to, from, next) {
            if (!['create:game', 'games:settings'].includes(to.name)) {
                this.$store.dispatch('setHomework', null);
                this.$store.dispatch('setPuzzleGame', null);
            }
            next();
        }
    }
</script>
